import { useReveal, SpringParallax, Image, VideoLoop } from '@ccg/core';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Text$1 from '../../basics/Text/Text.js';
import CssIcon from '../../basics/Icon/Icon.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import Tags$1 from '../Tags/Tags.js';
import StyledTeaserHero from './TeaserHero.style.js';

const TeaserHero = ({
  headline,
  image,
  topic,
  accentColor,
  tags,
  video,
  excerpt,
  link
}) => {
  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledTeaserHero, {
    className: "teaserHero",
    accentColor: accentColor,
    topic: topic,
    ref: ref,
    isVisible: isVisible
  }, /*#__PURE__*/React$1.createElement(SpringParallax, null, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    className: "teaserHero__link"
  }, link), image || video ? /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible,
    revealColor: accentColor ? accentColor.secondary : undefined,
    className: "teaserHero__media"
  }, image && !video ? /*#__PURE__*/React$1.createElement(Image, {
    src: image.src || image.url,
    srcset: image.srcset,
    alt: image.alt,
    sizes: "(min-width: 768px) 50vw, 100vw",
    className: "teaserHero__image",
    lazy: true
  }) : null, video ? /*#__PURE__*/React$1.createElement(VideoLoop, {
    src: video.url,
    loop: true,
    className: "teaserHero__video"
  }) : null) : null, /*#__PURE__*/React$1.createElement("div", {
    className: "teaserHero__content"
  }, topic && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "teaserHero__topic",
    transform: "uppercase"
  }, topic), /*#__PURE__*/React$1.createElement(Tags$1, {
    accentColor: accentColor ? accentColor.secondary : undefined,
    className: "teaserHero__tags",
    horizontal: true,
    tags: tags,
    variant: "small"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "teaserHero__headline"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "h2",
    variant: "subline"
  }, headline, /*#__PURE__*/React$1.createElement(CssIcon, null))), /*#__PURE__*/React$1.createElement(Text$1, {
    className: "teaserHero__excerpt",
    content: excerpt
  })))));
};

TeaserHero.propTypes = {
  accentColor: PropTypes$1.shape({
    primary: PropTypes$1.string,
    secondary: PropTypes$1.string
  }),
  topic: PropTypes$1.string,
  headline: PropTypes$1.string.isRequired,
  image: PropTypes$1.shape({
    src: PropTypes$1.string,
    url: PropTypes$1.string,
    srcset: PropTypes$1.string,
    alt: PropTypes$1.string
  }),
  link: PropTypes$1.shape(),
  tags: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string,
    id: PropTypes$1.number
  })),
  video: PropTypes$1.shape({
    url: PropTypes$1.string
  }),
  excerpt: PropTypes$1.string.isRequired
};
TeaserHero.defaultProps = {
  accentColor: {
    primary: null,
    secondary: null
  },
  topic: null,
  image: null,
  link: null,
  tags: [],
  video: null
};

export default TeaserHero;
